import {AVAILABLE_LANGUAGES} from "../config";

export const VISUALIZER_MANAGEMENT_ACTIONS = {
  getState: "getState",
  checkState: "checkState",
  setState: "setState",
  visualizerIsLoaded: "visualizerIsLoaded",
  closeVisualizerNavigation: "closeVisualizerNavigation",
  visualizerIsSaved: "visualizerIsSaved",
}

export const DASHBOARD_MESSAGING_ACTIONS = {
  updateCartItems: "updateCartItems", // parent -> visualizer
  setCostPrices: "setCostPrices", // parent -> visualizer
  jobDataAfterUpdate: "jobDataAfterUpdate", // visualizer -> parent
  setReferralData: "setReferralData", // parent -> visualizer
}

export const hardcodedTaxObject = {
  city: null,
  fabricatorId: document.kvConfig.userId,
  laborRate: 0,
  materialRate: 0,
  nameIntl: {
    ...AVAILABLE_LANGUAGES.map(key => { return {[key]: "Tax (included)"} }),
  },
  region: null,
  state: "",
  zip: null,
}
